import { render, staticRenderFns } from "./proofUpdate.vue?vue&type=template&id=4faba842&"
import script from "./proofUpdate.vue?vue&type=script&lang=js&"
export * from "./proofUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports